import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { DashboardsService } from "@shared/dashboards-service";

export const dashboardRedirectGuard: CanActivateFn = async (_route, state) => {
    const router = inject(Router);
    const dashboards = inject(DashboardsService);

    const isBareCardView = /^\/?card-view\/?$/.test(state.url ?? "");
    if (!isBareCardView) return true;

    try {
        const dashboardId = await dashboards.getSafeCurrentDashboardId();
        return router.createUrlTree(["card-view", dashboardId, "active"]);
    } catch (e) {
        return router.parseUrl("/accessunauthorized");
    }
};
